import { render, staticRenderFns } from "./TheMsgEnvelopeOpenedIcon.vue?vue&type=template&id=50cfdf20&"
import script from "./TheMsgEnvelopeOpenedIcon.vue?vue&type=script&lang=js&"
export * from "./TheMsgEnvelopeOpenedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports